// extracted by mini-css-extract-plugin
export default {"textarea-root":"Textarea_textarea-root__baJKO","textarea":"Textarea_textarea__gKOGs"};